import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Title, Meta } from '@angular/platform-browser';
import { ServiceComponent } from './service/service.component';

@Component({
  selector: 'app-services',
  standalone: true,
  imports: [
    CommonModule,
    ServiceComponent
  ],
  templateUrl: './services.component.html',
  styleUrls: ['./services.component.scss']
})
export class ServicesComponent implements OnInit {
  constructor(
    private titleService: Title, 
    private metaService: Meta
  ) {
    this.titleService.setTitle("Professional Influencer Management Services | Brandripplr");
    this.metaService.updateTag({ 
      name: 'description', 
      content: 'Find top micro-influencer management services in Dubai. Our expert agency helps you to grow your brand with powerful influencer campaigns.' 
    });
  }

  ngOnInit(): void {
  }
}
